import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft, Compass } from 'lucide-react';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CursorGlow from '../components/CursorGlow';

const NotFound = () => {
  const popularPages = [
    { name: 'Ana Sayfa', path: '/', icon: Home },
    { name: 'Hizmetlerimiz', path: '/?scrollTo=services', icon: Compass },
    { name: 'Hakkımızda', path: '/hakkimizda', icon: Compass },
    { name: 'İletişim', path: '/iletisim', icon: Compass },
    { name: 'Blog', path: '/blog', icon: Compass },
  ];

  return (
    <div className="min-h-screen bg-slate-900">
      <CursorGlow />
      <Header />

      <section className="relative pt-32 pb-20 overflow-hidden min-h-[80vh] flex items-center">
        <div className="absolute inset-0">
          <div className="absolute w-[600px] h-[600px] bg-cyan-500/20 rounded-full blur-3xl top-1/4 right-1/4 animate-pulse"></div>
          <div className="absolute w-[500px] h-[500px] bg-teal-500/20 rounded-full blur-3xl bottom-1/4 left-1/4 animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          {/* 404 Animation */}
          <div className="mb-8">
            <h1 className="text-[150px] md:text-[200px] font-bold bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent leading-none animate-pulse">
              404
            </h1>
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Sayfa Bulunamadı
          </h2>

          <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto">
            Aradığınız sayfa taşınmış, silinmiş veya hiç var olmamış olabilir. 
            Endişelenmeyin, size yardımcı olabiliriz!
          </p>

          {/* Action Buttons */}
          <div className="flex flex-wrap justify-center gap-4 mb-16">
            <Link to="/">
              <Button className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white px-8 py-6 text-lg group">
                <Home className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform" />
                Ana Sayfaya Dön
              </Button>
            </Link>
            <Link to="javascript:history.back()">
              <Button variant="outline" className="border-cyan-500/50 text-cyan-400 hover:bg-cyan-500/10 px-8 py-6 text-lg group">
                <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" />
                Geri Dön
              </Button>
            </Link>
          </div>

          {/* Popular Pages */}
          <div className="max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center justify-center gap-2">
              <Compass className="w-6 h-6 text-cyan-400" />
              Popüler Sayfalar
            </h3>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {popularPages.map((page, index) => (
                <Link
                  key={index}
                  to={page.path}
                  className="group bg-slate-800/40 backdrop-blur-sm border border-slate-700/50 rounded-xl p-6 hover:border-cyan-500/50 transition-all duration-300 hover:transform hover:-translate-y-1"
                >
                  <page.icon className="w-8 h-8 text-cyan-400 mb-3 group-hover:scale-110 transition-transform" />
                  <h4 className="text-white font-semibold group-hover:text-cyan-400 transition-colors">
                    {page.name}
                  </h4>
                </Link>
              ))}
            </div>
          </div>

          {/* Help Text */}
          <div className="mt-16 text-gray-500">
            <p>Hala aradığınızı bulamadınız mı?</p>
            <Link to="/iletisim" className="text-cyan-400 hover:text-cyan-300 underline">
              Bizimle iletişime geçin
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NotFound;
